import { render, staticRenderFns } from "./introduction-header.vue?vue&type=template&id=71e6a23e&scoped=true&"
import script from "./introduction-header.vue?vue&type=script&lang=js&"
export * from "./introduction-header.vue?vue&type=script&lang=js&"
import style0 from "./introduction-header.vue?vue&type=style&index=0&id=71e6a23e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e6a23e",
  null
  
)

export default component.exports